import styled from "styled-components";
import theme from "../../../Themes/light";
import Configuracoes from "../../../types/Configuracoes";
import { ThemeType } from "../../../types/Theme";

const textColorCatalogo = "#636466";
const backgroundColorCatalogo = "#f9f9f9";
const MockupCatalogoContainer = styled.div<{
  theme: ThemeType;
  configuracoes: Configuracoes;
}>`
    position: relative;
    width: 100%;
    min-height: 100%;
    max-width: 60rem;
    min-width: 37rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.25);
    border-radius: 20px 20px 0px 0px;
    z-index: 1;
    background-color: ${backgroundColorCatalogo};

    .header {
        padding: 3rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: ${({configuracoes}) =>
                configuracoes.catalogo.cor_primaria};
        width: 100%;
        border-radius: 0px 0px 16px 16px;
        gap: 12px;

        .infosEmpresa{
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: start;
        
            .nome {
                width: 100%;
                color: ${({configuracoes}) => configuracoes.catalogo.cor_secundaria};
                text-align: left;
                font-weight: bold;
                white-space: pre-wrap;
                word-wrap: break-word;
            }

            .descricao {
                width: 100%;
                color: ${({configuracoes}) => configuracoes.catalogo.cor_secundaria};
                text-align: left;
                white-space: pre-wrap;
                word-wrap: break-word;
                
                p{
                    margin: 0;
                }
            }

            .social{
                display: flex;
                align-items: center;
                gap: 1rem;

                .rede{
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: ${({configuracoes}) => configuracoes.catalogo.cor_secundaria};
                }
            }
        }
    }

    .categorias-container {
        display: flex;
        flex-wrap: nowrap;
        padding: 2rem 2rem;
        width: 100%;
        justify-content: flex-start;
        gap: 2rem;

        .categoria {
            width: 7rem;
            height: 7rem;
            border-radius: 50%;
            background-color: ${({theme}) => theme.colors.mockup};
        }
    }

    .banner-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .banner {
            margin: 0 3rem;
            border-radius: 10px;
            width: 100%;
            height: 20rem;
            background-color: ${({theme}) => theme.colors.mockup};
        }
    }

    .filtros {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        gap: 2rem;
        padding: 2rem 2rem;

        .filtro {
            width: 100%;
            border-radius: 30px;
            height: 20px;
            background-color: ${({theme}) => theme.colors.mockup};
        }
    }

    > .produtos {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(
      ${({configuracoes}) =>
              configuracoes.catalogo.quantidade_colunas_padrao.mobile},
      1fr
    );
        gap: 1rem;
        height: 72rem;
        overflow-y: scroll;
        padding: 2rem 3rem;
        margin-top: 4rem;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4rem;
            border-radius: 40px;
            background-color: ${({configuracoes}) =>
                    configuracoes.catalogo.cor_primaria};
        }

        > .produto {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 1rem;

            > .imagem {
                cursor: default;
                position: relative;
                width: 100%;
                min-height: 15rem;
                aspect-ratio: 1/1;

                > .fundoImagem {
                    border-radius: 15px;
                    width: 100%;
                    height: 100%;
                    opacity: 0.5;
                    background-color: ${theme.colors.mockup};
                }


            }

            .variacoes {
                display: flex;
                flex-direction: column;
                gap: 2px;
                width: 100%;

                .variacao {
                    position: relative;
                    width: 100%;
                    height: ${({configuracoes}) =>
                            Number.parseFloat(
                                    configuracoes.catalogo.quantidade_colunas_padrao.mobile
                            ) === 1
                                    ? "5rem"
                                    : "2rem"};
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .fundoVariacao {
                        background-color: ${theme.colors.mockup};
                        width: 100%;
                        height: 100%;
                        opacity: 0.5;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 6rem 0 1rem;

                        .variacaoEstoque {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            height: 100%;

                            .nomeVariacao {
                                text-align: center;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: bold;
                                flex-grow: 1;
                                min-height: 50%;
                            }

                            .estoque {
                                color: ${theme.colors.tertiary};
                                min-height: 50%;
                            }
                        }
                    }

                    .bolinha {
                        position: absolute;
                        min-height: 2rem;
                        width: 2rem;
                        align-self: center;
                        top: 0;
                        right: 0;
                        width: ${({configuracoes}) =>
                                Number.parseFloat(
                                        configuracoes.catalogo.quantidade_colunas_padrao.mobile
                                ) === 1
                                        ? "5rem"
                                        : "2rem"};
                        height: ${({configuracoes}) =>
                                Number.parseFloat(
                                        configuracoes.catalogo.quantidade_colunas_padrao.mobile
                                ) === 1
                                        ? "5rem"
                                        : "2rem"};
                        padding: ${({configuracoes}) =>
                                Number.parseFloat(
                                        configuracoes.catalogo.quantidade_colunas_padrao.mobile
                                ) === 1
                                        ? "5px"
                                        : "2px"};

                        .fundoBolinha {
                            border-radius: 50%;
                            width: 100%;
                            height: 100%;
                            background-color: ${({configuracoes}) =>
                                    configuracoes.catalogo.cor_primaria};
                        }
                    }
                }

                .expandir {
                    text-align: center;
                    color: #afafaf;
                    background-color: #f6f6f6;
                    border-bottom-left-radius: 15px;
                    border-bottom-right-radius: 15px;
                    margin-top: 3px;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-top: solid 2px;
                    border-color: ${({configuracoes}) =>
                            configuracoes.catalogo.cor_primaria};
                }
            }

            .botaoCompartilhar {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 100%;

                .botao {
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.7rem;
                    color: ${textColorCatalogo};

                    svg {
                        width: ${({configuracoes}) =>
                                Number.parseFloat(
                                        configuracoes.catalogo.quantidade_colunas_padrao.mobile
                                ) === 1
                                        ? "2.4rem"
                                        : "1.75rem"};
                        height: ${({configuracoes}) =>
                                Number.parseFloat(
                                        configuracoes.catalogo.quantidade_colunas_padrao.mobile
                                ) === 1
                                        ? "2.4rem"
                                        : "1.75rem"};
                        fill: ${textColorCatalogo};
                    }
                }
            }
        }
    }

    .footer {
        width: 100%;
        .footer-container {
            display: flex;
            padding: 2rem 2rem 1rem 2rem;
            width: 100%;
            gap: 2rem;
            align-items: center;

            .infos {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 4px;
                width: 100%;

                .nome {
                    color: ${textColorCatalogo};
                    font-weight: bold;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                }

                .descricao {
                    width: 100%;
                    color: ${textColorCatalogo};
                    text-align: left;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    word-break: break-word;
                    overflow-wrap: anywhere;

                    p,
                    span,
                    h1,
                    h2,
                    h3,
                    h4,
                    h5,
                    h6 {
                        width: 100%;
                        text-align: left;
                        margin: 0;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                    }
                }

                .redes {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    color: ${textColorCatalogo};

                    .rede {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                    }
                }
            }
        }

        .endereco {
            position: relative;
            padding: 2rem 4rem 2rem 4rem;
            color: ${textColorCatalogo};
            white-space: pre-wrap;
            word-wrap: break-word;
            text-align: center;

            span {
                color: ${textColorCatalogo};
            }

            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
                height: 0.1rem;
                background-color: ${({theme}) => theme.colors.elements};
                border-radius: 99px;
                width: 80%;
            }
        }
    }
`;

const LogoContainer = styled.div<{ theme: ThemeType }>`
  background-color: transparent;
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export { LogoContainer, MockupCatalogoContainer };

